/**
 * Created by swandelow on 19/12/17.
 */
import {Component, OnInit} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {SessionService} from "./core/session.service";
import {BackgroundColorService} from "./root/background-color/background-color.service";
import {VersionCheckService} from "./core/version-check.service";
import {ActivatedRoute, Params} from "@angular/router";
import {ConsoleLoggerService} from "./core/console-logger.service";
import {LoggerService} from "./core/logger.service";
import {CookieOptions, CookieService} from "ngx-cookie";

@Component({
    selector: 'root-cmp',
    providers: [ConsoleLoggerService],
    templateUrl: './root.component.html'
})
export class RootCmp implements OnInit{

    lookup: any;
    path:string;
    endLoading:boolean=false;

    constructor(private sessionService: SessionService, private translate: TranslateService,
                private backColor: BackgroundColorService, private versionCheckService:VersionCheckService,
                private activatedRoute: ActivatedRoute, private logger : LoggerService,
                private _cookieService: CookieService) {
        this.lookup = this;
        translate.setDefaultLang("es");
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((params: Params) => {
            let log = params['doLogger'];
            this.logger.setDebugMode(log);
        });

        this.versionCheckService.initVersionCheck('../web/assets/version.json');
        this.sessionService.getSubject().subscribe(message => {
            if(message.done) {
                this.endLoading = true;
            }
        })
    }

    getBackColor(){
        return this.backColor.getBack();
    }

    isLoggedIn() {
        return this.sessionService.isLoggedIn();
    }

    isWhiteBackground(): boolean {
        return this.backColor.getBack() === 'WHITE-BACK';
    }

    isWhiteSmokeBackground(): boolean {
        return this.backColor.getBack() === 'WHITESMOKE-BACK';
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/root.component.ts